import React, { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';

const SIDEBAR_WIDTH = 220;

const AdminLayout = () => {
    const token = localStorage.getItem('admin_token');

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [open, setOpen] = useState(window.innerWidth >= 768);

    // Hooks FIRST (important)
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            setOpen(!mobile); // desktop → open, mobile → closed
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Auth check AFTER hooks
    if (!token) {
        return <Navigate to="/admin/login" replace />;
    }

    return (
        <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
            <Sidebar
                open={open}
                isMobile={isMobile}
                setOpen={setOpen}
            />

            {/* MAIN CONTENT */}
            <div
                style={{
                    marginLeft: isMobile ? 0 : SIDEBAR_WIDTH,
                    transition: 'margin-left 0.3s ease'
                }}
            >
                {/* Mobile Top Bar */}
                {isMobile && (
                    <div style={topBar}>
                        <button
                            style={menuBtn}
                            onClick={() => setOpen(true)}
                        >
                            ☰
                        </button>
                        <span style={{ fontWeight: 600 }}>Admin Panel</span>
                    </div>
                )}

                <div style={{ padding: '20px' }}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default AdminLayout;

/* ---------- styles ---------- */

const topBar = {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    background: '#c31a1a',
    color: '#fff',
    position: 'sticky',
    top: 0,
    zIndex: 900
};

const menuBtn = {
    fontSize: '22px',
    background: 'none',
    border: 'none',
    color: '#fff',
    marginRight: '15px',
    cursor: 'pointer'
};
